module.exports = __webpack_public_path__ + "img/service-location.d6f1c8f9.svg";